import React from "react";
import moment from "moment";

const DateFormatter = ({ date, format = "DD MMM YYYY, HH:mm" }) => {
  const parsedDate = moment(date);

  if (!parsedDate.isValid()) return <span>-</span>;
  return <span>{parsedDate.format(format)}</span>;
};

export default DateFormatter;
